<template>
  <div class="step step-four rvr-reservation-confirmation">
  <ReservationConfirmation />
  </div>
</template>

<script>

import useStepNavigation from "@/composables/useStepNavigation";
import ReservationConfirmation from "@/components/public/forms/ReservationConfirmation.vue";
import useTokenManager from "@/composables/useTokenManager";
import {onMounted} from "vue";
import useReservations from "@/composables/useReservations";
import useReservationData from "@/composables/useReservationData";

export default {
  name: 'PublicStepFour',
  components: {ReservationConfirmation},
  setup() {
    const { curStep } = useStepNavigation();
    const { removeToken } = useTokenManager();
    const {clearReservations} = useReservations();
    const {clearReservationData} = useReservationData();
    curStep.value = 4;

    onMounted( () => {
      //Cleanup
      removeToken();
      clearReservations();
      clearReservationData();
    });
  },
};
</script>

<style scoped>
.step {background: #e9e9e9; padding: 20px; border-radius: 4px;}
</style>
